/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowercase`)
};

const es_sg_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minúsculas`)
};

const de_sg_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleinbuchstaben`)
};

const nl_sg_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleine letters`)
};

const fr_sg_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuscules`)
};

const it_sg_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuscolo`)
};

const pt_br2_sg_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minúscula`)
};

const pt_sg_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minúsculas`)
};

const ja_sg_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小文字`)
};

const zh_sg_lowercase = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小写`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_lowercase = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_lowercase(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_lowercase", locale)
	if (locale === "en") return en_sg_lowercase(inputs)
	if (locale === "es") return es_sg_lowercase(inputs)
	if (locale === "de") return de_sg_lowercase(inputs)
	if (locale === "nl") return nl_sg_lowercase(inputs)
	if (locale === "fr") return fr_sg_lowercase(inputs)
	if (locale === "it") return it_sg_lowercase(inputs)
	if (locale === "pt-BR") return pt_br2_sg_lowercase(inputs)
	if (locale === "pt") return pt_sg_lowercase(inputs)
	if (locale === "ja") return ja_sg_lowercase(inputs)
	return zh_sg_lowercase(inputs)
};